import $ from "jquery";
import vuwer from "@@assets/scripts/vuwer";

vuwer.add("pageNav", {
	selector: "#page_nav",
	closeMenuByScroll: true,
	
	onReady($self) {
		if(!$self) {
			return false;
		}
		
		this.$switch = $("#page_nav_switch");
		this.$content = $self.children(".content");
		!this.$content.length && (delete this.$content);
		
		if(this.$switch.length) {
			this.$switch.on("change", e => {
				const isOpen = e.target.checked;
				this.$switch.parent().toggleClass("is-open", isOpen);
				
				if(this.$content) {
					const { innerHeight } = window;
					const siteHeaderHeight = vuwer.get("siteHeader").$self.outerHeight();
					this.$content.css({
						"max-height": isOpen ? innerHeight - siteHeaderHeight : ""
					});
				}
				
				if(this.closeMenuByScroll) {
					if(isOpen) {
						this._scrollTopOnOpen = vuwer.$window.scrollTop();
						vuwer.$window.on("scroll.closeMenu", e => this._closeMenuByScroll());
					} else {
						vuwer.$window.off(".closeMenu");
					}
					
				} else {
					const overflow = isOpen ? "hidden" : "";
					vuwer.get("body").$self.css({ overflow });
				}
			}).prop("checked", false).trigger("change", [true]);
		}
	},
	
	_closeMenuByScroll() {
		const abs = Math.abs(vuwer.$window.scrollTop() - this._scrollTopOnOpen);
		(abs > 100) && this.$switch.prop("checked", false).trigger("change", [true]);
	}
});
